export enum RouteType {
	BASE = "/",
	LOGIN = "login",
	LOGIN_CALLBACK = "auth/callback/google",
	// DASHBOARD = 'dashboard',
	DASHBOARD = "report",
	REPORT = "report",
	REPORT_SUMMARY = "report/summary/:candidateId",
	RATINGS = "ratings",
	TS1_RATING_FORM = "ratings/:id",
	TS1_RATING_FORM_DRAFT = "ratings/:id/draft/:draftId",
	RATING_QUICK_SUMMARY = "quick-summary",
	RATING_QUICK_SUMMARY_DETAILS = "quick-summary-details",
	REPORT_DETAILS = "report/:id",
	FORMS = "forms",
	NEW_FORM = "forms/new",
	EDIT_FORM = "forms/:id",
	INSTRUCTOR_VERIFICATION = "instructor-verification",
	ERROR = "error",
	NOTFOUND = "404",
	USER_MANAGEMENT = "users",
	NEW_USER = "users/new",
	EDIT_USER = "user/:id",
	ADMIN = "admin",
	PROFILE = "profile",
	PENDING = "pending",
	PILOT_DATA = "pilot-data",
	PILOT_DATA_UPLOAD = "pilot-data/upload",
	PILOT_DATA_FOLDERS = "pilot-data/:staffId/folders",
	PILOT_DATA_FILES = "pilot-data/:staffId/folders/:folderId/files",
	CHECKLIST = "checklist",
	CHECKLIST_DETAIL = "checklist/:trainingAssessmentId",
	CHECKLIST_FEEDBACK = "checklist/:trainingAssessmentId/feedback",
	CHECKLIST_STANDALONE_FEEDBACK = "checklist/feedback/:taskId",
	FEEDBACK = "feedback",
	MY_FEEDBACK = "my-feedback",
	MY_FEEDBACK_DETAIL = "my-feedback/:submissionId",
	FEEDBACK_NEW = "feedback/new",
	FEEDBACK_EDIT = "feedback/:id/edit",
	FEEDBACK_RESPONSES = "feedback/:id/responses",
	FEEDBACK_RESPONSE = "feedback/:id/responses/:submissionId",
}

export enum Roles {
	ADMIN = "admin",
	INSTRUCTOR = "instructor",
	PILOT = "pilot",
	OFFICE_ADMIN = "office admin",
	GROUP_ADMIN = "group admin",
	CABIN_CREW = "cabin crew",
	CABIN_CREW_INSTRUCTOR = "cabin crew instructor",
}

export enum Rank {
	FO = "fo",
	SFO = "sfo",
	CAPTAIN = "captain",
}

export enum RankLabels {
	fo = "First Officer",
	sfo = "Senior First Officer",
	so = "Second Officer",
	captain = "Captain",
}
export enum AOC {
	maa = "maa",
	taa = "taa",
	iaa = "iaa",
	paa = "paa",
	aax = "aax",
	tax = "tax",
	aac = "aac",
}

export enum CandidateRole {
	PF = "pilot_flying",
	PM = "pilot_monitoring",
	NONE = "none",
}
